<template>
  <div class="orderList-container">
      <div class="contener-item fbox fbox-ac">
        <div class="check-box fsh" v-if="type">
          <Checkbox @on-change="checkbox" v-model="listObj[item.id].active"></Checkbox>
        </div>
        <div class="fbox fg1 fbox-w" v-if="listObj[item.id]">
          <div class="biaoti fg1" style="minWidth: 200px">
            <!-- 标题 -->
            <div class="title fbox fbox-ac">
              <p class="title-lable tc fsh m-r-5" v-if="listObj[item.id].preinstallMajor">{{listObj[item.id].preinstallMajor.short}}</p>
              <p class="titles fg1 color-black font-weight-b ell">{{listObj[item.id].name}}</p>
            </div>
            <!-- 老师 -->
            <div class="teacherList fbox">
              <div class="teacher tc" v-for="(teacher, i) in listObj[item.id].teacher" :key="i" v-show="i < 3">
                <tk-avatar>
                  <tk-image :src="teacherObj[teacher].headPortrait || 'http://qingbo-oss.oss-cn-beijing.aliyuncs.com/dba81e13-181d-4aa3-b872-bf15d8df199f.png'" width="100" height="100"></tk-image>
                </tk-avatar>
                <p class="tc f16 color-gray">{{teacherObj[teacher].nickname}}</p>
              </div>
            </div>
          </div>
          <!-- 简介 -->
          <div class="synopsis fbox fg1" style="minWidth: 150px">
            <tk-icon class="fsh m-r-5" color="#8e9299" >jihe</tk-icon>
            <div class="ell_2 color-gray fg1" v-if="listObj[item.id].type === '0'">
              <!-- {{listObj[item.id].ordinaryCourse || 0}}个基础课程，{{listObj[item.id].kernelCourse || 0}}个核心课程，{{listObj[item.id].expandCourse || 0}}个拓展课程&nbsp;&nbsp;共{{listObj[item.id].allCourse || 0}}节课 -->
              {{listObj[item.id].ordinaryCourse || 0}}个基础课程，{{listObj[item.id].kernelCourse || 0}}个核心课程，{{listObj[item.id].expandCourse || 0}}个拓展课程&nbsp;&nbsp;共{{listObj[item.id].allPreinstallNum || 0}}个课时
            </div>
            <div class="ell_2 color-gray fg1" v-else>
              <!-- 共{{listObj[item.id].num || 0}}节课 -->
              共{{listObj[item.id].preinstallNum || 0}}个课时
            </div>
          </div>
        </div>
        <div v-if="type" @click="deletes(listObj[item.id].objectId)" class="delete fsh m-l-5">删除</div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'orderList',
  props: ['type', 'item', 'listObj', 'teacherObj'],
  data () {
    return {
    }
  },
  mounted () {

  },
  methods: {
    checkbox () {
      this.$emit('checkbox')
    },
    deletes (id) {
      this.$emit('deletes', id)
    }
  }
}
</script>

<style lang='scss' scoped>

.contener-item{
  width: 100%;
  padding: 32px 39px;
  box-sizing: border-box;
  border-top: 1px dotted #E2E2E2;
  background-color: #fff;
  &:nth-child(1){
    border-top: 0;
  }
}
.title{
  width: 100%;
  .title-lable{
    display: inline-block;
    width: 42px;
    height: 26px;
    line-height: 26px;
    background: #DCAF80;
    border-radius: 4px;
    font-size: 16px;
    color: #ffffff;
    font-weight: 400;
  }
  .titles{
    font-size: 24px;
  }
}
.synopsis{
  margin-top: 10px;
  img{
    width: 29px;
    height: 29px;
    margin-right: 5px;
  }
  div{
    height: 50px;
  }
}
.teacherList{
  margin: 30px 0 20px;
  width: 100%;
  // overflow-x: scroll;
  .teacher{
    margin-right: 30px;
    img{
      width: 55px;
      height: 55px;
      border-radius: 50%;
    }
  }
}

.check-box{
  margin-right: 21px;
  ::v-deep{
    .ivu-checkbox-inner{
      width: 26px;
      height: 26px;
    }
    .ivu-checkbox-inner:after, .ivu-checkbox-inner:after{
      width: 8px;
      height: 16px;
      top: 2px;
      left: 8px;
    }
  }
}
.delete{
  cursor: pointer;
}
.biaoti{
  // height: 40px;
}
@media(max-width: 992px) {
  .biaoti{
    // height: 25px;
  }
  .contener-item{
    padding: 10px 10px !important;
  }
  .title{
    .title-lable{
      width: 40px !important;
      height: 20px !important;
      line-height: 20px !important;
      font-size: 14px !important;
    }
    .titles{
      font-size: 16px !important;
    }
  }
  .check-box{
    margin-right: 10px !important;
  }
  .synopsis{
    font-size: 14px !important;
    margin-top: 0 !important;
  }
  .check-box{
    // width: 30px;
    // text-align: center;
    ::v-deep{
      .ivu-checkbox-inner{
        width: 16px !important;
        height: 16px !important;
      }
      .ivu-checkbox-inner:after, .ivu-checkbox-inner:after{
        width: 4px !important;
        height: 8px !important;
        top: 2px !important;
        left: 5px !important;
      }
    }
  }
  .teacherList {
    margin: 10px 0;
  }
}
</style>
